import apiService from "apiService";
import React, { useEffect, useState } from "react";
import { toast } from "view/component/Alert";
import TableTanpaNumber from "view/component/TableTanpaNumber";

const FormScreening = ({ id, setId, visit, umur }) => {
  useEffect(() => {
    if (id != 0) {
      checkScreening();
    }
  }, [id]);
  const [question, setquestion] = useState([]);
  const getQuestion = async () => {
    let res = await apiService.get(
      "ilp/ref_screening_question?screening_id=" + id
    );
    if (res?.code == 200) {
      setquestion(res.data);
    } else {
      setquestion([]);
    }
  };

  const [screening_patient, setscreening_patient] = useState(null);

  const checkScreening = async () => {
    let res = await apiService.get(
      `/ilp/screening_patient/history_by_visit_screening?visit_id=${visit.id}&screening_id=${id}`
    );
    if (res.code == 200) {
      if (res.data.length > 0) {
        setscreening_patient(res.data[0]);
      } else {
        createScreeningForm();
      }
    }
  };

  const createScreeningForm = async () => {
    let par = {
      visit_id: visit.id,
      patient_nik: visit.patients.nik,
      screening_id: id,
      clinic_id: visit.clinic_id,
      umur: umur,
      result: "Screening belum selesai",
    };
    // console.log(par);
    let res = await apiService.post("/ilp/screening_patient/save", par);
    if (res.code == 200) {
      setscreening_patient(res.data);
    } else {
      alert("screening pasien gagal ter create");
    }
  };
  const [debounce, setdebounce] = useState(null);
  const postScreening = (data, e, key, ky) => {
    // console.log(data, e, key, ky);
    let q = question;
    let type = data.question[0].type; //cek option atau bukan jika option decimal string
    let genAnswer;
    switch (type) {
      //tipe option hasilnya langsung nilainyaa
      case "option":
        genAnswer = {
          ...data.question[0],
          result: e.value,
        };
        break;
      case "decimal_string":
        //tipe option hasilnya objek dari numerator dan denumnya
        genAnswer = {
          ...data.question[0],
          result: {
            ...data.question[0].answer,
            ...q[ky].result?.answer[0]?.result,
            [key]: e.value,
          },
        };
        break;
      default:
        genAnswer = {
          ...data.question[0],
          result: e.value,
        };
        break;
    }
    let par = {
      visit_id: visit.id,
      screening_id: id,
      screening_patient_id: screening_patient.id,
      screening_question_id: data.id,
      answer: [genAnswer],
    };
    q[ky] = { ...q[ky], result: par };
    setquestion(q);
    setdebounce(par); //buat debounce
  };

  useEffect(() => {
    let time = debounce?.answer[0]?.type == "option" ? 100 : 1500;
    const delay = setTimeout(() => {
      if (checkAllfilled(debounce) && debounce != null) {
        // console.log(debounce);
        toast({ status: "info", text: `text menyimpan data` });
        postData();
      }
    }, time);
    return () => clearTimeout(delay);
  }, [debounce]);

  const postData = async () => {
    let res = await apiService.post("/ilp/screening_patient/answer", debounce);
    if (res.code == 200) {
      toast({ status: "success", text: `berhasil menyimpan data` });
    } else {
      toast({ status: "error", text: `gagal menyimpan data` });
    }
  };
  const checkAllfilled = (par) => {
    let ans = par?.answer?.result;
    let question = par?.answer?.answer;
    let status = [];
    if (ans) {
      Object.keys(question).forEach(function (key, index) {
        if (ans[key] != "") {
          status.push(true);
        } else {
          status.push(false);
        }
      });
    }
    let res = status.some((e) => e == false) ? false : true; //cek jika ada yang kosong dari jawaban
    return res;
  };

  const generate_answer = (data, ky) => {
    // console.log(data);
    let view = [];
    if (data.category == "") {
      if (data.question[0].type == "option") {
        let ans = data.question[0].answer;
        let defVal = "";
        let val = screening_patient.answer?.find(
          (a) => JSON.parse(a.answer)[0].statement == data.question[0].statement
        );
        if (val) {
          defVal = JSON.parse(val.answer)[0].result;
        }
        Object.keys(ans).forEach(function (key, index) {
          view.push(
            <div className="custom-control custom-radio mb-3">
              <input
                name={data.question[0].statement}
                className="custom-control-input"
                id={data.question[0].statement + "_" + key}
                value={ans[key]}
                type="radio"
                defaultChecked={defVal ? defVal == ans[key] : false}
                onChange={(e) => postScreening(data, e.target, key, ky)}
              />
              <label
                className="custom-control-label"
                htmlFor={data.question[0].statement + "_" + key}
              >
                {key}
              </label>
            </div>
          );
        });
      } else {
        let ans = data.question[0].answer;
        let defVal = "";
        let val = screening_patient.answer?.find(
          (a) => JSON.parse(a.answer)[0].statement == data.question[0].statement
        );
        if (val) {
          defVal = JSON.parse(val.answer)[0].result;
        }
        Object.keys(ans).forEach(function (key, index) {
          view.push(
            <div className="mb-3">
              <label
                className="form-control-label"
                htmlFor={data.question[0].statement + "_" + key}
              >
                {key}
              </label>
              <input
                name={data.question[0].statement}
                className="form-control form-control-sm "
                id={data.question[0].statement + "_" + key}
                // value={ans[key]}
                defaultValue={defVal}
                disabled={data.is_system}
                type={data.question[0].type}
                onChange={(e) => postScreening(data, e.target, key, ky)}
              />
            </div>
          );
        });
      }
    } else {
      data.question.map((b, c) => {
        let ans = b.answer;
        let isi = [];
        Object.keys(ans).forEach(function (key, index) {
          if (b.type == "option") {
            let defVal = "";
            let val = screening_patient.answer?.find(
              (a) => JSON.parse(a.answer)[0].statement == b.statement
            );
            if (val) {
              defVal = JSON.parse(val.answer)[0].result;
            }
            isi.push(
              <div className="custom-control custom-radio mb-3 ml-3">
                <input
                  name={b.statement}
                  className="custom-control-input"
                  id={b.statement + "_" + key}
                  value={ans[key]}
                  type="radio"
                  defaultChecked={defVal ? defVal == ans[key] : false}
                  onChange={(e) => postScreening(data, e.target, key, ky)}
                />
                <label
                  className="custom-control-label"
                  htmlFor={b.statement + "_" + key}
                >
                  {key}
                </label>
              </div>
            );
          } else if (b.type == "decimal_string") {
            let defVal = "";
            let val = screening_patient.answer?.find(
              (a) => JSON.parse(a.answer)[0].statement == b.statement
            );
            if (val) {
              defVal = JSON.parse(val.answer)[0].result;
            }
            isi.push(
              <div>
                <label
                  htmlFor="example-text-input"
                  className="col-md-12 col-form-label col-form-label-sm"
                >
                  {key}
                </label>
                <div className="col-md-12">
                  <input
                    name={b.statement}
                    className="form-control form-control-sm "
                    id={b.statement + "_" + key}
                    size={4}
                    type="number"
                    onChange={(e) => postScreening(data, e.target, key, ky)}
                    defaultValue={defVal ? defVal[key] ?? "" : ""}
                  />
                </div>
              </div>
            );
          } else {
            let defVal = "";
            let val = screening_patient.answer?.find(
              (a) => JSON.parse(a.answer)[0].statement == b.statement
            );
            if (val) {
              defVal = JSON.parse(val.answer)[0].result;
            }
            isi.push(
              <div>
                <div className="col-md-12">
                  <input
                    name={b.statement}
                    className="form-control form-control-sm"
                    id={b.statement + "_" + key}
                    size={40}
                    type={b.type}
                    defaultValue={defVal}
                    disabled={data.is_system}
                    onChange={(e) => postScreening(data, e.target, key, ky)}
                  />
                </div>
              </div>
            );
          }
        });
        let generate = (
          <div>
            <div>
              <b>{b.statement}</b>
            </div>
            <div className="row">{isi}</div>
          </div>
        );
        view.push(generate);
      });
    }
    return view;
  };

  const generate_question = (data, ky) => {
    let view = [];
    if (data.category != "") {
      view.push(<div>{data.category}</div>);
    } else {
      view.push(<div>{data.question[0].statement}</div>);
    }
    return view;
  };
  useEffect(() => {
    if (screening_patient) {
      getQuestion();
    }
  }, [screening_patient]);
  return (
    <div>
      <div className="card-body">
        <div style={{ float: "right", marginBottom: "5px" }}>
          <a onClick={setId} className="btn btn-sm btn-danger text-white">
            tutup
          </a>
        </div>
        <div>
          <TableTanpaNumber
            className="table table-responsive"
            headers={["No", "Pertanyaan", "Jawaban"]}
            data={question}
            columnMapper={(a, key) => [
              a.category != "" ? a.question[0].number : a.number,
              generate_question(a, key),
              generate_answer(a, key),
            ]}
            issearch={false}
            pagination={false}
          />
        </div>
      </div>
      {/* <div className="modal-footer">
        <button className="btn btn-primary" onClick={() => postScreening()}>
          simpan
        </button>
      </div> */}
    </div>
  );
};

export default FormScreening;
